import React, { useRef, useEffect } from 'react';
import { useKarmaPoolContext } from '../../state/KarmaPoolContext';

function SpotifyPlayer({ spotifyCode }) {
    const playerRef = useRef(null);
    const karmaContext = useKarmaPoolContext();
    let EmbedController;

    const [isPlaying, setIsPlaying] = React.useState(false);

    const [forcePause, setForcePause] = React.useState(false);

    useEffect(() => {
        window.onSpotifyIframeApiReady = (IFrameAPI) => {
            let options = {
                uri: "spotify:" + spotifyCode.replace("/", ":"),
                width: "100%",
                height: "100%",
                theme: 'dark'
            };
            let callback = (controller) => {
                EmbedController = controller;

                // Listener for the 'ready' event
                EmbedController.addListener('ready', () => {
                    console.log('The Spotify Embed has initialized');
                });

                // Listener for the 'playback_update' event
                EmbedController.addListener('playback_update', ({ isPaused }) => {
                    console.log('The Spotify Embed has updated its playback state to ' + (isPaused ? 'paused' : 'playing'));
                    if (!isPaused && !isPlaying && !forcePause) {
                        setIsPlaying(true);
                        //karmaContext.contentPlayingManager.setCurrentlyPlayingContent({id: spotifyCode, type: "SPOTIFY"});
                    }
                });
            };
            IFrameAPI.createController(playerRef.current, options, callback);
        };

        // Ensure the Spotify iFrame API script is loaded
        if (!window.SpotifyIframeAPI) {
            const script = document.createElement('script');
            script.src = 'https://open.spotify.com/embed-podcast/iframe-api/v1'; 
            document.body.appendChild(script);
        }
    }, [spotifyCode]);

    useEffect(() => {  
        console.log("Spotify: spotifyCode: " + spotifyCode);
        console.log("Spotify: currentlyPlayingContent: " + karmaContext.contentPlayingManager.currentlyPlayingContent.id);
        if (EmbedController && karmaContext.contentPlayingManager.currentlyPlayingContent.id !== spotifyCode && isPlaying)
        {
            setForcePause(true);
            setIsPlaying(false);
            EmbedController.togglePlay(); // This pauses the Spotify content if it's playing

            // in 1 second remove force
            setTimeout(() => {
                setForcePause(false);
            }
            , 1000);
        }
    }, [karmaContext.contentPlayingManager.currentlyPlayingContent]);

    return (
        <div>
            <iframe src={"https://open.spotify.com/embed/" + spotifyCode + "&theme=0"} 
                    ref={playerRef}
                    title = {"Spotify Player - " + spotifyCode}
            width="100%" height="100%" frameBorder="0" allowtransparency="true" allow="encrypted-media"></iframe>
        </div>
    );
}

export default SpotifyPlayer;
